import { ComponentProps } from 'react'

import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup as MuiRadioGroup, styled } from '@mui/material'

export type RadioGroupOption = {
  value: string
  label: string
}

export type RadioGroupProps = ComponentProps<typeof MuiRadioGroup> & {
  label?: string
  options: RadioGroupOption[]
  disabled?: boolean
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ label, options, disabled, ...props }) => {
  return (
    <FormControl
      margin="dense"
    >
      {label && <StyledFormLabel id={props.name}>{label}</StyledFormLabel>}
      <MuiRadioGroup
        aria-labelledby={props.name}
        {...props}
      >
        {options.map(option => (
          <FormControlLabel key={option.value} disabled={disabled} value={option.value} label={option.label} control={<Radio />} />
        ))}
      </MuiRadioGroup>
    </FormControl>
  )
}

const StyledFormLabel = styled(FormLabel)`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  font-weight: 600;
  position: relative;
  transform: none;
  margin-bottom: ${(props) => props.theme.typography.pxToRem(3)};
`